/** Descrição da categoria raiz "Finalidade" no cadastro de categorias (id varia por ambiente). */
export const DESCRICAO_CATEGORIA_PAI_FINALIDADE = 'Finalidade';

export interface CategoriaPaiFinalidadeLike {
  categoria_id?: number;
  categoria_descricao?: string;
  categoria_pai?: string | number | null;
}

export function isCategoriaPaiRaiz(
  categoria_pai: string | number | null | undefined
): boolean {
  if (categoria_pai === undefined || categoria_pai === null) return true;
  const s = String(categoria_pai).trim();
  return s === '' || s === '0';
}

/**
 * Obtém o categoria_id do nó pai cuja descrição é exatamente "Finalidade".
 * Com múltiplos candidatos, prefere o que parece categoria raiz (sem pai).
 */
export function resolveIdCategoriaPaiFinalidade(
  categorias: CategoriaPaiFinalidadeLike[]
): number | null {
  const matches = categorias.filter(
    (c) =>
      c.categoria_descricao?.trim() === DESCRICAO_CATEGORIA_PAI_FINALIDADE
  );
  if (matches.length === 0) return null;
  if (matches.length === 1) {
    const id = matches[0].categoria_id;
    return id != null ? id : null;
  }
  const root = matches.find((m) => isCategoriaPaiRaiz(m.categoria_pai));
  const chosen = root ?? matches[0];
  const id = chosen.categoria_id;
  return id != null ? id : null;
}

export function categoriaFilhaDoPaiFinalidade(
  cat: { categoria_pai?: string | number | null },
  idPaiFinalidade: number | null
): boolean {
  if (idPaiFinalidade === null) return false;
  return String(cat.categoria_pai) === String(idPaiFinalidade);
}
